<template>
    <div class="product">
        <div class="top">
            <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-bottom: 4.8vw;">
                <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
                <el-breadcrumb-item>Products</el-breadcrumb-item>
            </el-breadcrumb>
            <div style="display: flex;justify-content: space-between;">
                <div class="filter" @click="drawer = true">
                    <p v-if="fiforckd == false">Filter</p>
                    <p v-else>Checked</p>
                    <img src="../assets/imgs/uploads/mobile/mdi_filter.png" alt="">
                </div>
                <el-select class="sort" v-model="valuesort" placeholder="Sort by..." :popper-append-to-body="false"
                    @change="getGoodsList">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
                <!-- <div class="sort">
                    <p>Sort by...</p>
                    <i style="color: #000;" class="el-icon-arrow-down"></i>
                </div> -->
            </div>

        </div>
        <el-drawer title="Filter By" :modal="false" :size="drawerWidth" direction="ltr" :visible.sync="drawer">
            <div style="padding: 0 8vw 26.667vw;">
                <div class="title" style="margin-top: 0;">{{ $t('list.ordertype') }}</div>
                <el-radio-group v-model="checkedOrderType" style="margin-left: 5.333vw;">
                    <el-radio :label="0" style="margin-bottom: 4.8vw;" @click.native.prevent="cancel(0)">In Stock</el-radio>
                    <br>
                    <el-radio :label="1" style="margin-bottom: 4.8vw;"
                        @click.native.prevent="cancel(1)">Pre-Order</el-radio>
                    <br>
                    <el-radio :label="2" @click.native.prevent="cancel(2)">Group Buying</el-radio> <br>
                </el-radio-group>
                <div class="title">{{ $t('list.brands') }}</div>
                <el-checkbox-group v-if="this.$store.getters.getUser" style="margin-left: 5.333vw;"
                    v-model="brandCheckedList" @change="getGoodsList">
                    <el-checkbox v-for="(brand, index) in brands" :key="index" class="brand-item"
                        :label="brand.brand"></el-checkbox>
                </el-checkbox-group>
                <el-checkbox-group v-else v-model="brandCheckedList" @change="getGoodsList" style="margin-left: 5.333vw;">
                    <el-checkbox v-for="(brands1, index) in brands1" :key="index" class="brand-item"
                        :label="brands1.brand"></el-checkbox>
                </el-checkbox-group>
                <el-checkbox-group v-model="categoryCheckedList" @change="getGoodsList">
                    <div v-for="category in categories" :key="category.id" style="margin-bottom: 2.667vw;">
                        <div style="font-size: 4.267vw; font-weight: bold; margin-bottom: 2.667vw;">{{ category.categoryName
                        }}
                        </div>
                        <el-checkbox style="margin-left: 5.333vw;" v-for="subCategory in category.children"
                            :key="subCategory.id" class="category-item" :label="subCategory.id">{{ subCategory.categoryName
                            }}</el-checkbox>
                    </div>
                </el-checkbox-group>
                <div class="filterbtn">
                    <div class="left" @click="clearFilters">Clear filters</div>
                    <div class="right" @click="drawer = false">View Results</div>
                </div>
            </div>
        </el-drawer>
        <div style="padding: 4.8vw 7.467vw;margin-top: 28vw;">
            <div id="top1"></div>
            <div v-if="loading" style="text-align: center">
                <img src="../assets/imgs/uploads/Animation.gif" alt="">
            </div>
            <div v-else-if="goods.length > 0">
                <div style="display: flex;justify-content: start;color: #959595;margin-bottom: 4.8vw;">Display
                    <span style="font-weight: bold;margin: 0 5px;color: #333;">{{ total > 10 ? 10 : total }}/{{ total
                    }}</span>results
                </div>
                <div style="display: flex;flex-wrap: wrap;">
                    <div class="toysItem" v-for="(item, index) in goods" :key="index">
                        <router-link :to="{ path: '/detail', query: { spuId: item.id } }">
                            <img v-lazy="item.imgUrl" alt=""
                                style="width: 40.267vw;height: 40.187vw;border-radius: 3.2vw 3.2vw 0 0;">
                            <div class="skuname" style="height: auto;">
                                <span style="font-size: 3.467vw;">{{ item.brand }}</span>
                            </div>
                            <div class="skuname" style="margin-top: 0;">
                                <span style="font-size: 3.467vw;">{{ item.name }}</span>
                            </div>
                            <div class="more">More</div>
                        </router-link>
                    </div>
                </div>
                <div style="display: flex;justify-content: center;">
                    <el-pagination layout="prev, pager, next" :page-size="pageSize" :total="total" :pager-count="5"
                        background @current-change="currentChange"></el-pagination>
                </div>
            </div>
            <el-row v-else style="text-align: center">
                <el-col :span="24" style="font-size: 5.333vw;font-weight: bold;color: #959595;">Sorry...</el-col>
                <el-col :span="24" style="font-size: 5.333vw;font-weight: bold;color: #959595;">No relevant products were
                    found</el-col>
                <el-col :span="24" style="font-size: 4.267vw;color: #959595;">Please look at other
                    products.</el-col>
                <el-col :span="24"><img style="width: 66.667vw; height: 70.933vw;" src="../assets/imgs/cart-empty.png"
                        alt=""></el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
export default {
    metaInfo: {
        meta: [
            {
                name: 'description',
                content: 'Explore our extensive selection of cat and dog toys at our online pet toy store. Find a wide range of toys to entertain and enrich the lives of your pets.Browse through our curated collection of cat and dog toys on our website. Discover toys designed to stimulate your pets natural instincts and provide hours of fun.Shop for high-quality cat and dog toys online. Choose from a variety of toys, including plush toys, interactive toys, and treat dispensers, to keep your pets happy and engaged.Elevate your pets playtime with our diverse range of toys for cats and dogs. From chew toys to puzzle toys, we have everything you need to enhance your pets wellbeing.Treat your furry friends to the best toys available online. Explore our selection of innovative and durable cat and dog toys crafted for both entertainment and enrichment.'
            },
            {
                name: 'keywords',
                content: 'Cat and dog toys,Pet toys online,Online pet toy store,Interactive pet toys,Plush pet toys,Chew toys for pets,Puzzle toys for cats and dogs,Treat dispensing toys,Enrichment toys for pets,High-quality pet toys'
            }
        ]
    },
    data() {
        return {
            categoryList: [], //分类列表
            categoryID: [], // 分类id
            product: "", // 商品列表
            productList: "",
            total: 0, // 商品总量
            pageSize: 10, // 每页显示的商品数量
            currentPage: 1, //当前页码
            activeName: "-1", // 分类列表当前选中的id
            search: "", // 搜索条件
            brands: [],
            brands1: [
                { brand: 'Gifts For Paws' },
                { brand: 'Gigwi' },
                { brand: 'PETGEEK' },
                { brand: 'SKIPDAWG' }
            ],
            selectedIndex: null,
            categories: '',
            messages: [],
            messages1: [],
            clicks: '',
            highlightedIndex: null, // 选中的文字索引,
            checkedOrderType: '',
            brandCheckedList: [],
            brandCheckedList1: [],
            categoryCheckedList: [],
            minAmount: '',
            maxAmount: '',
            options: [{
                value: '1',
                label: 'Best Sellers'
            }, {
                value: '2',
                label: 'Newest Arrivals',
            }, {
                value: '0',
                label: 'Default'
            }],
            valuesort: '',
            keyword: '',
            goods: [],
            loading: true,
            fiforckd: false,
            drawer: false,
            drawerWidth: '90%', // Drawer宽度
        };
    },
    computed: {
        summaryCategories: function () {
            let arr = []
            this.categories.foreach(item => {
                item.children.foreach(item => {
                    arr.push(item)
                })
            });
            return arr;
        }
    },
    mounted() {
        this.getfenlei();
    },
    activated() {
        this.getBrands()
    },
    watch: {
        checkedOrderType: 'viewResults',
        tag: 'viewResults',
        brandCheckedList: 'viewResults',
        categoryCheckedList: 'viewResults',
    },
    methods: {
        handleSearch() {
            this.getGoodsList()
        },
        getBrands() {
            this.$axios
                .post("/api/mall/member/getUserBrands", {
                    id: this.$store.getters.getUser.id,
                })
                .then(res => {
                    this.brands = res.data.data
                    this.brandCheckedList1 = this.brands.map(item => item.brand)
                    this.getGoodsList()
                })
                .catch(err => {
                    return Promise.reject(err);
                });
        },
        getGoodsList() {
            this.brandCheckedList1 = this.brandCheckedList
            if (!this.$store.getters.getUser) {
                this.$axios.post("/api/mall/spu/getPublicPage", {
                    pageNum: this.currentPage,
                    pageSize: this.pageSize,
                    orderType: this.checkedOrderType,
                    brands: this.brandCheckedList1,
                    categoryIds: this.categoryCheckedList,
                    sortType: this.valuesort,
                    keyword: this.keyword
                })
                    .then(res => {
                        this.goods = res.data.data.records;
                        this.total = res.data.data.total;
                        this.loading = false;
                        window.scrollTo(0, 0);
                    }).catch(err => {
                        return Promise.reject(err);
                    });
            } else {
                this.$axios.post("/api/mall/spu/page", {
                    pageNum: this.currentPage,
                    pageSize: this.pageSize,
                    orderType: this.checkedOrderType,
                    brands: this.brandCheckedList1,
                    categoryIds: this.categoryCheckedList,
                    sortType: this.valuesort,
                    keyword: this.keyword
                })
                    .then(res => {
                        this.goods = res.data.data.records;
                        this.total = res.data.data.total;
                        this.loading = false;
                        window.scrollTo(0, 0);
                    }).catch(err => {
                        return Promise.reject(err);
                    });
            }

        },
        getTypeData(val) {
            this.$axios
                .post("/api/mall/sku/page", {
                    pageNum: this.currentPage,
                    pageSize: this.pageSize,
                    proType: val
                })
                .then(res => {
                    this.product = res.data.data.records;
                    this.total = res.data.data.total;
                })
                .catch(err => {
                    return Promise.reject(err);
                });
            this.highlightedIndex = val
        },
        // 返回顶部
        backtop() {
            const timer = setInterval(function () {
                const top = document.documentElement.scrollTop || document.body.scrollTop;
                const speed = Math.floor(-top / 5);
                document.documentElement.scrollTop = document.body.scrollTop =
                    top + speed;
                if (top === 0) {
                    clearInterval(timer);
                }
            }, 20);
        },
        // 页码变化调用currentChange方法
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.getGoodsList()
            this.goAnchor("mtop")
        },
        goAnchor(sectionId) {
            var anchor = document.getElementById(sectionId);
            // chrome
            document.body.scrollTop = anchor.offsetTop - 280;
            // firefox
            document.documentElement.scrollTop = anchor.offsetTop - 280;
            // safari
            window.pageYOffset = anchor.offsetTop - 280;
        },
        // 向后端请求分类列表数据
        getCategory() {
            this.$axios
                .post("/api/product/getCategory", {})
                .then(res => {
                    const val = {
                        category_id: 0,
                        category_name: "全部"
                    };
                    const cate = res.data.category;
                    cate.unshift(val);
                    this.categoryList = cate;
                })
                .catch(err => {
                    return Promise.reject(err);
                });
        },
        getfenlei() {
            this.$axios
                .post("/api/mall/category/all")
                .then(res => {
                    this.categories = res.data.data
                })
                .catch(err => {
                    return Promise.reject(err);
                });
        },
        // 向后端请求全部商品或分类商品数据    
        getData() {
            this.$axios
                .post("/api/mall/sku/page", {
                    pageNum: this.currentPage,
                    pageSize: this.pageSize
                })
                .then(res => {
                    this.product = res.data.data.records;
                    this.total = res.data.data.total;
                })
                .catch(err => {
                    return Promise.reject(err);
                });
        },
        // 通过搜索条件向后端请求商品数据
        getProductBySearch() {
            this.$axios
                .post("/api/mall/sku/page", {
                    pageNum: this.currentPage,
                    pageSize: this.pageSize,
                    name: this.search
                })
                .then(res => {
                    this.product = res.data.data.records;
                    this.total = res.data.data.total;
                })
                .catch(err => {
                    return Promise.reject(err);
                });
        },
        selectbrands(index) {
            this.selectedIndex = index === this.selectedIndex ? null : index;
        },
        cancel(e) {
            if (this.checkedOrderType === e) {
                this.checkedOrderType = null
            } else {
                this.checkedOrderType = e
            }
            this.getGoodsList()
        },
        clearFilters() {
            this.checkedOrderType = ''
            this.brandCheckedList = []
            this.categoryCheckedList = []
            this.getGoodsList()
            this.drawer = false
        },
        viewResults() {
            if (this.checkedOrderType !== '' ||
                this.brandCheckedList.length !== 0 ||
                this.categoryCheckedList.length !== 0) {
                this.fiforckd = true
            } else {
                this.fiforckd = false
            }
        },
    }
};
</script>

<style scoped>
.product {
    font-size: 16px;
    border-top: 1px solid #c7c7c7;
    margin-top: -1px;
}

.top {
    position: fixed;
    z-index: 2;
    padding: 18px 29px 12px;
    width: 100%;
    border-bottom: 1px solid #D9D9D9;
    background-color: #fff;
}

.filter {
    width: 153px;
    height: 37px;
    padding: 0 10.8px 0 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #c7c7c7;
    border-radius: 10px;
    border: 1px solid #959595;
}

.filter img {
    width: 10px;
    height: 10px;
}

.sort {
    width: 153px;
    height: 37px;
}

::v-deep .sort .el-input__inner {
    width: 153px;
    height: 37px;
    border-color: #b1b1b1;
    border-radius: 10px;
}

::v-deep .sort .el-select-dropdown__item.selected {
    color: #CA141D;
}

.title {
    font-weight: bold;
    margin: 20px 0;
}

.brand-item,
.category-item {
    display: block;
    margin-bottom: 18px;
}

.filterbtn {
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 0 30px;
    background-color: #CA141D;
    width: 337.5px;
    height: 83px;
    z-index: 3;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.filterbtn div {
    font-size: 14px;
    width: 120px;
    height: 36px;
    border-radius: 7px;
    background-color: #fff;
}

.filterbtn .left {
    background-color: #FB9A9F;
    color: #CA141D;
    display: flex;
    justify-content: center;
    align-items: center;
}

.filterbtn .right {
    background-color: #FFF;
    color: #CA141D;
    display: flex;
    justify-content: center;
    align-items: center;
}

.toysItem {
    width: 153px;
    height: 255px;
    border-radius: 12px;
    border: 1px solid #D9D9D9;
    margin-right: 11px;
    margin-bottom: 15px;
    position: relative;
}

.toysItem:nth-child(2n) {
    margin-right: 0px;
}

.skuname {
    font-size: 12px;
    color: #333;
    font-weight: bold;
    text-align: center;
    height: 10vw;
    margin-top: 8.3px;
}

.more {
    margin: 1.867vw auto 0;
    width: 45px;
    height: 19px;
    display: flex;
    border-radius: 24px;
    justify-content: center;
    align-items: center;
    background-color: #545454;
    color: #FFF;
    font-size: 12px;
    font-weight: bold;
}

::v-deep .el-drawer__header {
    padding: 35px 30px 24px;
    margin-bottom: 0;
    color: #CA141D;
    font-weight: bold;
}

::v-deep [class*=" el-icon-"] {
    font-weight: bold;
}

::v-deep .el-radio {
    color: #333;
}

::v-deep .el-checkbox {
    color: #333;
}

::v-deep .el-breadcrumb__inner.is-link:hover {
    color: #000;
}

::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #333;
    border-color: #333;
}

::v-deep .el-radio__input.is-checked .el-radio__inner {
    border-color: #333;
    background: #333;
}

::v-deep .el-radio__label {
    font-size: 14px;
}

::v-deep .el-checkbox__label {
    font-size: 14px;
}

::v-deep .el-radio__input.is-checked+.el-radio__label {
    color: #333;
    font-weight: bold;
}

::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #333;
    font-weight: bold;
}

::v-deep .el-select .el-input.is-focus .el-input__inner {
    border-color: #333;
}

::v-deep .el-checkbox {
    -webkit-tap-highlight-color: transparent !important;
}

::v-deep .el-input__inner:focus {
    border-color: #333;
}

::v-deep .el-radio__inner:hover {
    border-color: #333;
}

::v-deep .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #333;
}

::v-deep .el-checkbox__inner:hover {
    border-color: #333;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #000;
    color: #FFF;
}

::v-deep .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
    -webkit-box-shadow: 0 0 0px 0px transparent;
    box-shadow: 0 0 0px 0px transparent;
}
</style>